/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useMutation, useQueryClient } from "@tanstack/react-query";
import { fetcher } from "./fetcher";
import { queryKeys, mutationKeys } from "./queryKeys";

export const useWaitingListJoin = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: mutationKeys.joinWaitingList,
    mutationFn: (data) => fetcher({ method: "POST", url: "/public/waiting-list/item/", data }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.waitingList.all });
    },
  });
};
